<template>
<div class="chapter">
<div class="inner_page">
<p class="partnum">Unit 1</p>
<p class="parttit">F<span class="small">AMILIES</span></p>
<p class="image"><img alt="Images" src="images/common.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// unit01.vue?1cc4ce3e